<template>
  <productOrder :default_type="default_type"></productOrder>
</template>

<script>
  import productOrder from "./productOrder";
  import {
    TYPE_SELL,
    TYPE_PURCHASE,
    TYPE_RETURN_SELL,
    TYPE_RETURN_PURCHASE,
    TYPE_CHANGES_IN,
    TYPE_CHANGES_OUT,
    TYPE_MOVING,
    TYPE_CHANGES_INVENTORY
  } from "./const.js";
  export default {
    name: "productOrderChangeInventory",
    components: {
      productOrder
    },
    data(){
      return {
        default_type: TYPE_CHANGES_INVENTORY
      }
    },
  };
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/apps/product_order/productOrderChangeInventory.vue